import { ReactNode, useRef } from 'react';
import { Focusable } from 'react-aria';
import { MenuButton } from '@szhsin/react-menu';

import Tooltip from '@/design_system/Tooltip';
import IconCross from '@/icons/Cross.svg';
import { createBEMClasses } from '@/utils/classname';

const { element } = createBEMClasses('filters-menu');

export const FilterTag = ({
  ref,
  onClick,
  onKeyDown,

  label,
  value,
  tooltip,
  onClear,
}: {
  ref?: React.Ref<HTMLButtonElement>;
  onClick?: () => void;
  onKeyDown?: () => void;

  label: ReactNode;
  value: ReactNode;
  tooltip?: ReactNode;
  onClear?: () => void;
}) => {
  const triggerRef = useRef<HTMLDivElement>(null);

  const base = (
    <div className={element('filter-tag')} ref={triggerRef}>
      <Focusable>
        <MenuButton
          ref={ref}
          onClick={onClick}
          onKeyDown={onKeyDown}
          className={element('filter-tag__menu-button')}
        >
          <span>{label}:</span> {value}
        </MenuButton>
      </Focusable>
      <button className={element('filter-tag__clear')} onClick={onClear}>
        <IconCross />
      </button>
    </div>
  );

  if (tooltip) {
    return (
      <Tooltip content={tooltip} triggerRef={triggerRef} delay={500} closeDelay={200}>
        {base}
      </Tooltip>
    );
  }

  return base;
};
